import React, { useMemo, useEffect } from 'react';

/* Material UI */
import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';

/* React redux */
import { useDispatch, useSelector } from 'react-redux';

/* Project */
import { changeControls, resetDiscrepancyStepper } from 'commons/commons.actions';
import { reselectObjects } from 'utils/helper';
import DiscrepancyStepper from '../DiscrepancyStepper/DiscrepancyStepper';

function DiscrepancyModal() {
  const dispatch = useDispatch();
  const { discrepancyStepper, objects: objectsState } = useSelector((state) => state.app);

  const objects = useMemo(() => reselectObjects(objectsState), [objectsState]);

  const { controls, loaders } = discrepancyStepper;
  const isUploading = loaders?.create;

  const handleClose = () => {
    // Prevent closing if files are being uploaded to S3
    if (isUploading) {
      return;
    }
    dispatch(resetDiscrepancyStepper());
  };

  // Prevent browser tab/window close during upload
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isUploading) {
        e.preventDefault();
        e.returnValue = 'Hay archivos subiéndose a S3. ¿Estás seguro que deseas salir?';
        return e.returnValue;
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isUploading]);

  return (
    <Dialog
      open={controls.openDialog}
      onClose={handleClose}
      PaperProps={{ sx: { minWidth: { lg: 700 }, minHeight: 200 } }}>
      <Box sx={{ m: 3 }}>
        <DiscrepancyStepper objects={objects} />
      </Box>
    </Dialog>
  );
}

export default DiscrepancyModal;
